import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from './IconBase';
const RssIcon = _ref => {
  let {
    title = 'RssIcon',
    ...props
  } = _ref;
  return React.createElement(IconBase, _extends({}, props, {
    title: title
  }), React.createElement("g", null, React.createElement("path", {
    d: "M11.536,45.491c-3.782,0-6.858,3.077-6.858,6.858s3.077,6.858,6.858,6.858c3.782,0,6.858-3.076,6.858-6.858 S15.317,45.491,11.536,45.491z"
  }), React.createElement("path", {
    d: "M5.819,25.954c-0.296-0.007-0.578,0.1-0.791,0.305c-0.212,0.205-0.33,0.486-0.33,0.78v8.8c0,0.58,0.456,1.057,1.036,1.084 c11.576,0.528,20.704,9.656,21.232,21.232c0.027,0.579,0.504,1.035,1.084,1.035h8.8c0.294,0,0.576-0.119,0.78-0.33 s0.314-0.497,0.305-0.791c-0.281-8.437-3.738-16.386-9.734-22.382C22.205,29.692,14.256,26.235,5.819,25.954z"
  }), React.createElement("path", {
    d: "M42.148,21.741C32.416,12.011,19.51,6.496,5.804,6.213C5.511,6.199,5.23,6.319,5.023,6.523 C4.815,6.728,4.697,7.007,4.697,7.298v8.795c0,0.589,0.469,1.07,1.058,1.085c22.031,0.553,40.403,18.926,40.955,40.955 c0.014,0.589,0.496,1.058,1.085,1.058h8.795c0.291,0,0.571-0.117,0.776-0.326c0.203-0.208,0.316-0.49,0.31-0.782 C57.392,44.376,51.877,31.469,42.148,21.741z"
  })));
};
export default RssIcon;
//# sourceMappingURL=RssIcon.js.map